/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { LinkType } from '../../../../../../../../../models/record/items/input-record.model';
import { Component, Input, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'record-icon-text',
  templateUrl: './record-icon-text.component.html',
  styleUrls: ['./record-icon-text.component.scss'],
  standalone: false
})
export class RecordIconTextComponent implements OnInit {
  @Input() text: string = '';
  @Input() icon!: IconDefinition;
  @Input() componentColor: string = '#5C5C5B';
  @Input() linkType?: LinkType;

  constructor() {}

  ngOnInit(): void {}

  onClick() {
    if (!this.linkType) return;
    let url = '';

    switch (this.linkType) {
      case LinkType.URL:
        url = this.getValidUrl(this.text);
        break;

      case LinkType.PHONE:
        url = `tel:${this.text}`;
        break;

      case LinkType.EMAIL:
        url = `mailto:${this.text}`;
        break;

      default:
        break;
    }

    if (url.length > 0) {
      window.open(url, '_blank');
    }
  }

  private getValidUrl(url: string) {
    if (!/^http[s]?:\/\//.test(url)) {
      url = `http://${url}`;
    }
    return url;
  }
}
